export const objectToArr = (obj: any) => Object.keys(obj).map(k => obj[k]);

